<button class="bg-style form-button"
    [ngClass]="{
        'cancel-btn': btnType === 'cancel',
        'confirm-btn': btnType === 'confirm',
        'danger-btn': btnType === 'danger'
    }">
    {{subtitle}}
</button>
